import type { GetScopedTypesenseKey } from '@cloudFunctions/types/typesense/getScopedTypesenseKey';
import type { PerformInitialTypesenseSync } from '@cloudFunctions/types/typesense/performInitialTypesenseSync';
import { invokeBackendRoute } from '@/backend/invoke';

export const getScopedTypesenseKey = async (
  props: GetScopedTypesenseKey.Props,
): Promise<GetScopedTypesenseKey.Result> =>
  invokeBackendRoute<GetScopedTypesenseKey.Result, GetScopedTypesenseKey.Props>(
    'getScopedTypesenseKey',
    props,
  );

export const performInitialTypesenseSync =
  async (): Promise<PerformInitialTypesenseSync.Result> =>
    invokeBackendRoute<PerformInitialTypesenseSync.Result>(
      'performInitialTypesenseSync',
    );
